module.exports = __webpack_public_path__ + "img/Heavy Lifting.c9fd7ccd.svg";